import { Device, until } from '@helpers/media';
import DownloadCard from '@stories/Components/Cards/DownloadCard/DownloadCard';
import React from 'react';
import S from './DownloadCards.styles';
const DownloadCards = (props) => {
    const sizes = props.cards.length > 1
        ? `470px`
        : `${until(866)} 100vw, ${until(Device.DesktopLarge)} 50vw, 696px`;
    return (React.createElement(S.Container, { id: props.anchorId, translations: props.translations, "data-multi-column": props.cards.length > 1 },
        React.createElement(S.Grid, null, props.cards.map((card) => (React.createElement(S.Card, { key: card.id },
            React.createElement(DownloadCard, { ...card, sizes: sizes })))))));
};
export default DownloadCards;
